import toast from "react-hot-toast";

export const emojiRegex =
/([\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2300}-\u{23FF}|\u{2B50}|\u{1F004}-\u{1F251}]+|\u{1F004}-\u{1F251}|\u{1F1E6}-\u{1F1FF})/gu;


export function formatField(field) {
    let formatted = field.replace(/_/g, " ");
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1);
    return formatted;
  }

  export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  export const pinCodeRegex = /^\d{6}$/;
  export  const ageRegex = /^\d+$/;
  export const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+([\/\w\.-]*)*\/?$/;

  export const fileSizeExtenshion = (data) => {

    const allowed_file_size = 10;
    if (data.size / (1024 * 1024) > allowed_file_size) {
      toast.error("File too large");
      return false;
    } else {
      const array_of_allowed_files = ["png", "jpeg", "jpg", "webp"];
      const file_extension = data.name.slice(
        ((data.name.lastIndexOf(".") - 1) >>> 0) + 2
      );
      if (!array_of_allowed_files.includes(file_extension)) {
        toast.error("Invalid file");
        return false;
      } else {
        return true;
      }
    }
  }